import { Menu, MenuProps } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";

type MenuItem = Required<MenuProps>['items'][number]

interface LevelKeysProps {
    key?: string;
    children?: LevelKeysProps[];
}

const SidebarLinks: MenuItem[] = [
    {
        key: "1",
        label: <Link to={'/'} >Dashboard</Link>,
    },
    {
        key: "18",
        label: <Link to={'/attendance'}>Check In / Out</Link>
    },
    {
        key: "19",
        label: <Link to={'/rooms'}>Room Management</Link>
    },
    {
        key: "sub1",
        label: "တရားစခန်းများဆိုင်ရာ",
        children: [
            {
                key: "2",
                label: <Link to={'/meditation-retreats'}>တရားစခန်းများ</Link>,
            },
            {
                key: "3",
                label: <Link to={'/news'}>သတင်း</Link>,
            },
            {
                key: "14",
                label: <Link to={'/contacts'}>အဆက်အသွယ်များ</Link>,
            }
        ]
    },
    {
        key: "sub2",
        label: "ယောဂီ Management",
        children: [
            {
                key: "4",
                label: <Link to={'/meditators'}>ယောဂီစာရင်း</Link>,
            },
            {
                key: "5",
                label: <Link to={'/meditator-list-by-retreat'}>တရားစခန်းအလိုက်ယောဂီစာရင်း</Link>,
            },
            {
                key: "6",
                label: <Link to={'/retreat-registrants'}>စာရင်းသွင်းထားသော ယောဂီများ</Link>,
            },
            {
                key: "7",
                label: <Link to={'/cancelled-registrants'}>စာရင်းပယ်ဖျက် ယောဂီများ</Link>,
            },
        ]
    },
    {
        key: "sub3",
        label: "လှူဒါန်းမှုဆိုင်ရာ",
        children: [
            {
                key: "8",
                label: <Link to={'/donations'}>အလှူရှင်များစာရင်း</Link>,
            },
            {
                key: "9",
                label: <Link to={'/alms-donors'}>ဆွမ်းအလှူရှင်များ</Link>,
            },
            {
                key: "10",
                label: <Link to={'/fund-donors'}>မတည်ငွေ အလှူရှင်များ</Link>,
            },
            {
                key: "11",
                label: <Link to={'/padetha-donors'}>ပဒေသာပင် အလှူရှင်များ</Link>,
            },
        ]
    },
    {
        key: "sub4",
        label: "Settings",
        children: [
            {
                key: "15",
                label: <Link to={'/payment-methods'}>Payment Methods</Link>,
            },
            {
                key: "12",
                label: <Link to={'/send-notification'}>Notification ပို့ရန်</Link>,
            },
            {
                key: "13",
                label: <Link to={'/new-account'}>အကောင့်ပြုလုပ်ရန်</Link>,
            },
            {
                key: "16",
                label: <Link to={'/users'}> User Accounts </Link>
            }, 
            {
                key: "17",
                label: <Link to={'/nfc'}>NFC Station</Link>
            }
        ]
    }
]

const getLevelKeys = (items1: LevelKeysProps[]) => {
    const key: Record<string, number> = {};
    const func = (items2: LevelKeysProps[], level = 1) => {
        items2.forEach((item) => {
            if (item.key) {
                key[item.key] = level;
            }
            if (item.children) {
                func(item.children, level + 1);
            }
        });
    };
    func(items1);
    return key;
};

const levelKeys = getLevelKeys(SidebarLinks as LevelKeysProps[]);

export function SidebarMenu() {

    const pathname = useLocation().pathname;

    const [activeKey, setActiveKey] = useState<string[]>(getActiveKey(pathname));
    const [stateOpenKeys, setStateOpenKeys] = useState<string[]>([]);

    const onOpenChange: MenuProps['onOpenChange'] = (openKeys) => {
        const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
        // open
        if (currentOpenKey !== undefined) {
            const repeatIndex = openKeys
                .filter((key) => key !== currentOpenKey)
                .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

            setStateOpenKeys(
                openKeys
                    // remove repeat key
                    .filter((_, index) => index !== repeatIndex)
                    // remove current level all child
                    .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
            );
        } else {
            // close
            setStateOpenKeys(openKeys);
        }
    };

    useEffect(() => {
        setActiveKey(getActiveKey(pathname));
    }, [pathname]);

    return (
        <>
            <Menu
                mode="inline"
                className="text-white"
                rootClassName="!bg-transparent sidebar-menu"
                items={SidebarLinks}
                selectedKeys={activeKey}
                openKeys={stateOpenKeys}
                onOpenChange={onOpenChange}
            />
        </>
    )
}

const getActiveKey = (pathname: string) => {

    if (pathname.includes("meditator-list-by-retreat")) {
        return ["5"];
    }

    if (pathname.includes("cancelled-registrants")) {
        return ["7"];
    }

    if (pathname.includes("retreat-registrants")) {
        return ["6"];
    }

    if(pathname.includes("attendance")){
        return ["18"]
    }

    if(pathname.includes("rooms")){
        return ["19"]
    }

    switch (pathname) {
        case "/":
            return ["1"];
        case "":
            return ["1"];
        case "/meditation-retreats":
            return ["2"];
        case "/news":
            return ["3"];
        case "/meditators":
            return ["4"];
        case "/meditator-list-by-retreat":
            return ["5"];
        case "/retreat-registrants":
            return ["6"];
        case "/cancelled-registrants":
            return ["7"];
        case "/donations":
            return ["8"];
        case "/alms-donors":
            return ["9"];
        case "/fund-donors":
            return ["10"];
        case "/padetha-donors":
            return ["11"];
        case "/send-notification":
            return ["12"];
        case "/new-account":
            return ["13"];
        case "/contacts":
            return ["14"];
        case "/payment-methods":
            return ["15"];
        case "/users":
            return ["16"];
        case "/nfc":
            return ["17"];
        case "/rooms":
            return ["19"];
        default:
            return ["1"];
    }
}